import { useRef, useState } from 'react';
import Popover from '@material-ui/core/Popover';
import PlateMaterialOptions from './PlateMaterialOptions';

export default function PlateExperimentVariables({experiment,experimentId,globalSet}){
  return (

    <div>
    {experiment.variableMap.map((item,ii) => {
            return item && (
              <NicknameItem {...{experimentId,state:experiment,item,variableId:ii,set:globalSet}}/>
            )
          })}
    </div>
  )
}

function SubstanceSelector({setSelectingSubstance,onSelectSubstance}){

  return (
    <div style={{position:"fixed", top:0, left:0, width:'100%', height:'100%'}} class="outline">




    </div>
  )




}


function NicknameItem({state,variableId,experimentId,item,value,set}){


  const [ selectingSubstance, setSelectingSubstance ] = useState(false);

  const [ inventoryItem, setInvItem ] = useState();

  const substanceNameRef = useRef();

  function onCloseSubstancePicker(){
    setSelectingSubstance(false);
    setInvItem();
  }

  return (
    <div class="sg-row v-center fair-margin-bottom">

    <div style={{
          width:15,height:15, borderRadius:30,
      marginRight:10,
          background:item.color
        }}/>


      <div onClick={() => setSelectingSubstance(true)} 
        ref={substanceNameRef} class="rel hoverable selectable clickable">
        <b>{item.substance}</b>
      </div>



      <div class="flex-expand"/>
      <div class="sg-row v-center">
        
        <div><input onChange={e => {
          set({ type:"setVariableDisplayText",
            experimentId,
            variableId,
            displayText:e.target.value
          })
        }} style={{
          width:50,
          fontSize:8,
          lineHeight:1,
        }} value={item.displayText}/></div>
        <button class="sg-row v-center" style={{

          fontSize:8,
          padding:3,
          top:0,
          right:0,
          width:30,
          height:15,
        }}>Reset</button>
      </div>

      <Popover open={selectingSubstance} anchorEl={substanceNameRef.current}

        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}


        onClose={onCloseSubstancePicker}>

        <div>
        <PlateMaterialOptions {...{
          state:{inventoryItem}, set:({inventoryItem}) => { setInvItem(inventoryItem) }
        }}/>
          <div class="sg-row small-margin">

            <div class="flex-expand"/>
            <button onClick={onCloseSubstancePicker} style={{fontSize:10}} class="small-margin-right btn btn-light btn-sm">Cancel</button>

            <button onClick={() => {
              set({
                type:"setSubstance",
                experimentId,
                variableId,
                substance:inventoryItem
              })
              onCloseSubstancePicker();
            }} style={{fontSize:10}} class="btn btn-primary btn-sm">Okay</button>
          </div>
        </div>


      </Popover>

    </div>
  )
}
